const track_read = (asset_type, word_count) => ({
    top: null,
    sent: false,
    conditions: {
        read_time: false,
        scroll_length: false,
    },
    init() {
        const reading_time = parseInt((word_count / 350) * 60);
        setInterval(() => {
            if (this.conditions.read_time || this.sent) {
                return;
            }
            this.conditions.read_time = true;
            this._eventWatcher();
        }, reading_time * 1000);
        this.top = this.$el.getBoundingClientRect().top;
    },
    _getScrollPercent() {
        var h = document.documentElement,
            b = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';
        return (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
    },
    _eventWatcher() {
        if (this.conditions.read_time && this.conditions.scroll_length) {
            this.$track('read_content', { c: asset_type }, ['ga']);
            this.sent = true;
        }
    },
    events: {
        ['@scroll.window']() {
            if (this.conditions.scroll_length || this.sent) {
                return;
            }
            if (this._getScrollPercent() > 90) {
                this.conditions.scroll_length = true;
            }
            this._eventWatcher();
        }
    }
});

export default track_read;